import React from "react";
import ReactDOM from "react-dom/client"; // Importa desde react-dom/client
import "./index.css";
import AppWithStyles from "./AppWithStyles";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWithStyles />
  </React.StrictMode>
);

reportWebVitals();